import React from 'react'
import { Separator } from '@mc/design-system'
import { Trans, useTranslation } from '@mc/i18n'
import { Header, HeaderContent } from '@mc/plans-ui'
import { FREE_TRIAL_I18N_NAMESPACE } from '../../../i18n'
import { useFreeTrial } from '../../../lib'

export const PlansHeader = () => {
  const { t } = useTranslation(FREE_TRIAL_I18N_NAMESPACE)
  const { trial } = useFreeTrial()

  return (
    <Header>
      <HeaderContent.MainTitle
        title={t('common.checkout.plans.title', {
          duration: trial.strings.duration,
        })}
        subtitle={
          <Trans
            i18nKey='common.checkout.plans.subtitle'
            values={{
              trialType: trial.strings.type.toLowerCase(),
            }}
            ns={FREE_TRIAL_I18N_NAMESPACE}
          >
            <span className='mc-text--bold' />
          </Trans>
        }
      />
      <div className='mc-px-4 mc-w-100 '>
        <Separator className='mc-mb-9 mc-mt-5' />
      </div>
    </Header>
  )
}
